// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var NpsSquareBoxForm$ReactHooksTemplate = require("./NpsSquareBoxForm.res.js");
var NpsRoundedBoxForm$ReactHooksTemplate = require("./NpsRoundedBoxForm.res.js");
var NpsConfigurableForm$ReactHooksTemplate = require("./NpsConfigurableForm.res.js");
var NpsRoundedBoxWithSmileyForm$ReactHooksTemplate = require("./NpsRoundedBoxWithSmileyForm.res.js");
var NpsGradientScaleWithSmileyForm$ReactHooksTemplate = require("./NpsGradientScaleWithSmileyForm.res.js");

function NpsForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var borderCss = props.borderCss;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var surveyTheme = props.surveyTheme;
  var customerInfo = props.customerInfo;
  var nps = props.nps;
  var componentType = Belt_Option.getWithDefault(Nps$ReactHooksTemplate.componentType(nps), "rounded_box_with_smiley");
  var configuration = Nps$ReactHooksTemplate.configuration(nps);
  switch (componentType) {
    case "custom" :
        return JsxRuntime.jsx(NpsConfigurableForm$ReactHooksTemplate.make, {
                    nps: nps,
                    customerInfo: customerInfo,
                    language: language,
                    mandatory: mandatory,
                    onChange: onChange,
                    borderCss: borderCss,
                    configuration: configuration,
                    substitutionVariables: substitutionVariables
                  });
    case "gradient_scale_with_smiley" :
        return JsxRuntime.jsx(NpsGradientScaleWithSmileyForm$ReactHooksTemplate.make, {
                    nps: nps,
                    customerInfo: customerInfo,
                    surveyTheme: surveyTheme,
                    language: language,
                    mandatory: mandatory,
                    onChange: onChange,
                    borderCss: borderCss,
                    configuration: configuration,
                    substitutionVariables: substitutionVariables
                  });
    case "rounded_box" :
        return JsxRuntime.jsx(NpsRoundedBoxForm$ReactHooksTemplate.make, {
                    nps: nps,
                    customerInfo: customerInfo,
                    language: language,
                    mandatory: mandatory,
                    onChange: onChange,
                    borderCss: borderCss,
                    configuration: configuration,
                    substitutionVariables: substitutionVariables
                  });
    case "square_box" :
        return JsxRuntime.jsx(NpsSquareBoxForm$ReactHooksTemplate.make, {
                    nps: nps,
                    customerInfo: customerInfo,
                    surveyTheme: surveyTheme,
                    language: language,
                    mandatory: mandatory,
                    onChange: onChange,
                    borderCss: borderCss,
                    configuration: configuration,
                    substitutionVariables: substitutionVariables
                  });
    default:
      return JsxRuntime.jsx(NpsRoundedBoxWithSmileyForm$ReactHooksTemplate.make, {
                  nps: nps,
                  customerInfo: customerInfo,
                  language: language,
                  mandatory: mandatory,
                  onChange: onChange,
                  borderCss: borderCss,
                  configuration: configuration,
                  substitutionVariables: substitutionVariables
                });
  }
}

var make = NpsForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
